export enum EnumSensePassPaymentMethod {
  CreditCard = 1,
  Ach = 2,
}
